import { useEffect, useState } from "react";
import { db, auth } from "../firebase";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
  arrayRemove,
  increment,
  getDoc
} from "firebase/firestore";
import { FaCheck, FaCross, FaEdit, FaHeart, FaPen, FaPlay, FaPlus, FaRemoveFormat, FaSave, FaTrash } from "react-icons/fa";
import { Button, Form, Modal } from "react-bootstrap";
import { useSwipeable } from "react-swipeable";
import { TbFlagCancel } from "react-icons/tb";
import { useRef } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import mixpanel from "mixpanel-browser";

export default function SubCard({ sub, onSwipe, nextSub, onEditSuccess }) {
  const [expanded, setExpanded] = useState(false);
  const [resistance, setResistance] = useState(20);
  const [loading, setLoading] = useState(false);

  const user = auth.currentUser;

  const [showModal, setShowModal] = useState(false); 
  const [folders, setFolders] = useState([]); 
  const [newFolderName, setNewFolderName] = useState("");

  const [view, setView] = useState("folders"); // "folders" | "playlist"
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [playlistSubs, setPlaylistSubs] = useState([]);
  const [currentAudio, setCurrentAudio] = useState(null);

  const [bgAudio, setBgAudio] = useState(null);
  const [selectedBg, setSelectedBg] = useState("none");
  const [subliminalOn, setSubliminalOn] = useState(false);

  const [saveSuccess, setSaveSuccess] = useState("");
  const [weOut, setWeOut] = useState(false);
  const [isLooping, setIsLooping] = useState(false);
  const isPlayingAllRef = useRef(false);
  const [playing, setPlaying] = useState(false);

  const [winnerOn, setWinnerOn] = useState(
    sub?.winners?.includes(user?.uid)
  );
  const [favoriteOn, setFavoriteOn] = useState(
    sub?.playlistUsers?.includes(user?.uid)
  );
  const [winnerCount, setWinnerCount] = useState(sub?.winners?.length || 0);
  const [updatingWinner, setUpdatingWinner] = useState(false);

  const [playCount, setPlayCount] = useState(sub?.playCount || 0);
  const [updatingPlay, setUpdatingPlay] = useState(false);

  const [userNeed, setUserNeed] = useState("");
  const DEFAULT_NEEDS = [
    "I am confident",
    "I am attractive",
    // "I am lucky",
  ];
  const [savedNeeds, setSavedNeeds] = useState(
    // user?.needs ? [...user.needs] : []
    DEFAULT_NEEDS
  );
  const [translatedText, setTranslatedText] = useState("");
  const [translating, setTranslating] = useState(false);
  // At the top of your component
  const [displayedContent, setDisplayedContent] = useState(sub.content);
  const [showNeedModal, setShowNeedModal] = useState(false);
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  const storage = getStorage();
  const audioCache = useRef({});
  let playIdRef = useRef(0);

  const [showPlayOverlay, setShowPlayOverlay] = useState(true);
  const [playlistCount, setPlaylistCount] = useState(
    sub?.playlistUsers?.length || 0
  );
  const [officialNeed, setOfficialNeed] = useState("");
  const [status, setStatus] = useState("← Swipe →");

  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(displayedContent);
  const [savingEdit, setSavingEdit] = useState(false);
  const [isTranslated, setIsTranslated] = useState(false);


  const backgroundSounds = [
  { name: "None", value: "none" },
  // { name: "Aum", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Faum1.mp3?alt=media&token=45306a36-f86d-4144-b176-103f12c9419f" },
  {name: "Aum 2", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Faum2.mp3?alt=media&token=dc96470f-35bd-4d16-a9f0-fefb2b07d0d1" },
  {name: "Fire", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Ffire.mp3?alt=media&token=c7512819-bfa1-490e-b48a-4c5f96e489da" },
  {name: "Guitar", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Fguitar.mp3?alt=media&token=89978714-edda-4367-8132-0b7a63f108fc" },
  { name: "Rain & Thunder", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Frain-thunder.wav?alt=media&token=708f0fbb-668f-4967-9261-85188bb7dd3f" },
  { name: "Ocean", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Focean-waves.mp3?alt=media&token=a4a4d8c7-4e18-4618-b7f5-ab153c3f386d" },
  {name: "River", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Friver.mp3?alt=media&token=0dba7e47-7ee9-4444-9d95-8c8602e4a6d5" },
  // { name: "Brown Noise", value: "/sounds/brown.mp3" },
  { name: "White Noise", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Fwhite-noise.mp3?alt=media&token=375918bb-82f2-410d-8221-acb57ea1bd15" },
  { name: "Forest", value: "https://firebasestorage.googleapis.com/v0/b/groupyarn-9a203.firebasestorage.app/o/sounds%2Fforest.mp3?alt=media&token=114ca803-119f-40d2-a654-466e01b30525" }
];


  useEffect(() => {
    if (!sub) return;

    const winners = sub.winners || [];

    setWinnerOn(winners.includes(user?.uid));
    setWinnerCount(winners.length);
    

    // play button count for new swppied subs
      setPlayCount(sub.playCount || 0);

      // playlist count
      setFavoriteOn(sub.playlistUsers?.includes(user?.uid));
      setPlaylistCount(sub.playlistUsers?.length || 0);

  }, [sub, user]);

  useEffect(() => {
    fetchNeeds();
  }, [user]);

  // Whenever sub.content changes (e.g., new card)
  useEffect(() => {
    setDisplayedContent(sub.content);
    setIsTranslated(false);
  }, [sub.content]);

  // useEffect(() => {
  //   if (!audioUnlocked) return;

  //   handlePlay(); // auto play new sub
  // }, [sub]);

  useEffect(() => {
    if (!audioUnlocked) return
    if ( !sub?.content) return;
    handlePlay();
  }, [sub]);

  // useEffect(() => {
  //   setShowPlayOverlay(false);
  // }, [sub?.id]);


  useEffect(() => {
    const unlock = async () => {
      const ctx = new AudioContext();
      await ctx.resume();
    };

    window.addEventListener("touchstart", unlock, { once: true });
    window.addEventListener("click", unlock, { once: true });
  }, []);

  // useEffect(() => {
  //   if(sub === 0){
  //     setShowPlayOverlay(true);
  //   }
  // }, [sub]);

  useEffect(() => {
    if (officialNeed && sub?.content) {
      handleTranslate(officialNeed);
    }
  }, [officialNeed, sub]);

  // useEffect(() => {
  //   if (!officialNeed) return;
  //   if (!sub?.content) return;

  //   // only run when sub changes (not when toggling)
  //   handleTranslate(officialNeed);
  // }, [sub]);

  useEffect(() => {
    setEditedContent(displayedContent);
  }, [displayedContent]);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (isEditing) return;
      // console.log("playing", playing );
      if(playing){
        stopCurrentAudio();
      }
      unlockAudio();
      onSwipe?.("left");
    },

    onSwipedRight: () => {
      if (isEditing) return;
      if(playing){
        stopCurrentAudio();
      }
      unlockAudio();
      onSwipe?.("right");
      // navigator.vibrate?.(10); // haptic feedback
      // 🔥 open save modal FIRST
      // await handleFavorite();

      // 🔥 then move to next card
      // onSwipe?.("right");
    },

    trackMouse: true
  });

  // 📂 Fetch folders 
  const fetchFolders = async () => { 
    if (!user) return; 
    const folderRef = collection(db, "subusers", user.uid, "folders"); 
    const snapshot = await getDocs(folderRef); 
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })); 
    // console.log("Fetched folders:", data);
    setFolders(data); 
  }; 
  
  // ❤️ Open modal 
  const handleFavorite = async () => { 
    if (!user) { alert("Login required"); return; 
    } 
      mixpanel.track("liked", {
      
    });
    await fetchFolders(); 
    setShowModal(true); 
  }; 
    
    // ➕ Create folder 
  const createFolder = async () => { if (!newFolderName.trim()) return; 
      mixpanel.track("create playlist", {
    });
    const folderRef = collection(db, "subusers", user.uid, "folders"); 
    await addDoc(folderRef, { name: newFolderName, subs: [], createdAt: serverTimestamp() }); 
    setNewFolderName(""); fetchFolders(); 

    
  }; 
  
  // 💾 Save to folder 
  const saveToFolder = async (folderId) => {
    try {
      const folderRef = doc(db, "subusers", user.uid, "folders", folderId);

      await updateDoc(folderRef, {
        subs: arrayUnion(sub.id)
      });

      // ✅ NEW: track user in sub doc
      const subRef = doc(db, "subs", sub.id);

      await updateDoc(subRef, {
        playlistUsers: arrayUnion(user.uid)
      });

      // instant UI update
      setPlaylistCount(prev => prev + 1);

      setFavoriteOn(true); // optimistic UI update

      // ✅ show success message instead of alert
      setSaveSuccess("Saved to playlist ✓");

      // optional: clear message after 2 sec
      setTimeout(() => {
        setSaveSuccess("");
      }, 2000);

    } catch (err) {
      console.error(err);
      setSaveSuccess("Failed to save");
    }
  }; 

  const handleResistanceSubmit = async (value) => {
    await addDoc(collection(db, "tests"), {
      subId: sub.id,
      resistance: Number(value),
      userId: user?.uid || null,
      createdAt: serverTimestamp()
    });
  };

  const handlePlay = async () => {
    setLoading(true); 
    const id = ++playIdRef.current;
    mixpanel.track("Playing Audio", {
        sub: displayedContent
    });
    // setPlayCount(prev => {
    //   // trigger small animation here if you want
    //   return prev + 1;
    // });
    try {
      await incrementPlayCount(); // increment play count in Firestore and UI
      await handlePlayText(displayedContent);

       // 🚨 if a new play started while this one was running, stop here
      if (id !== playIdRef.current) return;

    } catch (err) {
      console.error(err);
      alert("Failed to play audio");
    } finally {
      setLoading(false);
      setStatus("← Swipe →");
    }   
  };


  const incrementPlayCount = async () => {
    if (updatingPlay) return;

    setUpdatingPlay(true);

    const subRef = doc(db, "subs", sub.id);

    try {
      await updateDoc(subRef, {
        playCount: increment(1)
      });

      // ✅ update UI instantly (no wait for reload)
      setPlayCount(prev => prev + 1);

    } catch (err) {
      console.error(err);
    } finally {
      setUpdatingPlay(false);
    }
  };


 const toggleWinner = async () => {
  if (!user) {
    alert("Login required");
    return;
  }


  if (updatingWinner) return;
  // setStatus(winnerOn ? "Removing like..." : "Adding like...");
  setUpdatingWinner(true);

  const subRef = doc(db, "subs", sub.id);


  try {
    if (winnerOn) {
      // ❌ UNLIKE
      await updateDoc(subRef, {
        winners: arrayRemove(user.uid)
      });

      setWinnerOn(false);
      setWinnerCount(prev => Math.max(prev - 1, 0));

    } else {
      // ✅ LIKE
      await updateDoc(subRef, {
        winners: arrayUnion(user.uid)
      });

      setWinnerOn(true);
      setWinnerCount(prev => prev + 1);
    }

  } catch (err) {
    console.error(err);
  }finally {
    setUpdatingWinner(false);
  }
};

 const playAll = async () => {
    const myPlayId = ++playIdRef.current;
    isPlayingAllRef.current = true;

    mixpanel.track("Playall", {
        // tag: userNeed
    });

    for (let s of playlistSubs) {
      if (!isPlayingAllRef.current) break;

      await handlePlayText(s.content);

       // 🔥 CRITICAL: abort if a newer play session started
      if (myPlayId !== playIdRef.current) return;


      // ✅ double-check AFTER await
      if (!isPlayingAllRef.current) break;
    }
  };

  const stopPlayAll = () => {
    isPlayingAllRef.current = false;
    stopCurrentAudio(); // also stop current sound
  };



const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0; // convert to 32bit int
  }
  return Math.abs(h);
};



const handlePlayText = async (text) => { 
  
  const currentId = playIdRef.current;
    try {
      if (currentAudio) {
        currentAudio.stop?.();
      }
      if (currentId !== playIdRef.current) return;
      setPlaying(true);

      const fileName = `subs/${sub.id}_${hash(text)}.mp3`;
      const storageRef = ref(storage, fileName);

      let audioBuffer;

      // =====================================================
      // ✅ 1. CHECK MEMORY CACHE FIRST (FASTEST)
      // =====================================================
      if (audioCache.current[fileName]) {
        console.log("⚡ Using memory cache");

        audioBuffer = audioCache.current[fileName];
      } else {
        let audioUrl = null;

        // =====================================================
        // ✅ 2. CHECK FIREBASE STORAGE
        // =====================================================
        try {
          audioUrl = await getDownloadURL(storageRef);
          console.log("☁️ Found in Firebase");
          setStatus("Playing...");
        } catch (err) {
          console.log("❌ Not in storage → generating...");
        }

        // =====================================================
        // ✅ 3. GENERATE + UPLOAD IF MISSING
        // =====================================================
        if (!audioUrl) {
         setStatus("Please wait, generating audio...");
          const res = await fetch("/api/tts", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ text })
          });

          if (!res.ok) throw new Error("TTS failed");

          const blob = await res.blob();

          // upload
          await uploadBytes(storageRef, blob);

          audioUrl = await getDownloadURL(storageRef);

          console.log("✅ Uploaded new audio");

          // OPTIONAL: save to Firestore (only if base sub text)
          if (text === sub.content) {
            const subRef = doc(db, "subs", sub.id);
            await updateDoc(subRef, { audioUrl });
          }
        }

        // =====================================================
        // ✅ 4. FETCH + DECODE AUDIO
        // =====================================================
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

        if (audioCtx.state === "suspended") {
          await audioCtx.resume();
        }

        const audio = new Audio(audioUrl);
        audio.loop = true;
        audio.volume = subliminalOn ? 0.01 : 1;

        await audio.play();

        setCurrentAudio(audio);

        return new Promise((resolve) => {
          audio.onended = () => {
            if (currentId !== playIdRef.current) return;
            setPlaying(false);
            setStatus("← Swipe →");
            resolve();
          };
        });

        // ✅ SAVE TO MEMORY CACHE
        audioCache.current[fileName] = audioBuffer;
      }

      // =====================================================
      // ✅ 5. PLAY (REUSED OR NEW)
      // =====================================================
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

      if (audioCtx.state === "suspended") {
        await audioCtx.resume();
      }

      const source = audioCtx.createBufferSource();
      source.buffer = audioBuffer;

      const gainNode = audioCtx.createGain();
      const lowpass = audioCtx.createBiquadFilter();
      const compressor = audioCtx.createDynamicsCompressor();

      lowpass.type = "lowpass";
      lowpass.frequency.value = subliminalOn ? 1200 : 20000;
      gainNode.gain.value = subliminalOn ? 0.01 : 1;

      compressor.threshold.value = -50;
      compressor.knee.value = 40;
      compressor.ratio.value = 12;
      compressor.attack.value = 0;
      compressor.release.value = 0.25;

      source
        .connect(lowpass)
        .connect(compressor)
        .connect(gainNode)
        .connect(audioCtx.destination);

      source.start(0);

      setCurrentAudio(source);

      return new Promise((resolve) => {
        source.onended = () => {
          setPlaying(false);
          if (!isPlayingAllRef.current) return;
          resolve();
        };
      });

    } catch (err) {
      console.error("Audio failed:", err);
      setPlaying(false);
    }
  };


  const stopCurrentAudio = () => {
    if (currentAudio) {
      // HTML Audio
      if (currentAudio instanceof HTMLAudioElement) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
      }

      // Web Audio API
      if (currentAudio.stop) {
        try {
          currentAudio.stop();
        } catch (e) {}
      }

      setCurrentAudio(null);
    }

    setPlaying(false); // 🔥 IMPORTANT
    setIsLooping(false);
  };

  const openPlaylist = async (folder) => {
  setSelectedFolder(folder);
  setView("playlist");

  if (!folder.subs || folder.subs.length === 0) {
    setPlaylistSubs([]);
    return;
  }

  // 🔥 fetch subs by IDs
  const subsSnapshot = await getDocs(collection(db, "subs"));
    const allSubs = subsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    const filtered = allSubs.filter(s => folder.subs.includes(s.id));

    // latest → earliest
    filtered.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);

    setPlaylistSubs(filtered);
  };

  const removeFromFolder = async (subId) => {

      mixpanel.track("removeFromPLaylist", {
    
        });
        
      try {
        const folderRef = doc(
          db,
          "subusers",
          user.uid,
          "folders",
          selectedFolder.id
        );

        await updateDoc(folderRef, {
          subs: arrayRemove(subId)
        });

        // update UI instantly
        setPlaylistSubs(prev => prev.filter(s => s.id !== subId));

        setSaveSuccess("Removed from playlist");

        setTimeout(() => setSaveSuccess(""), 2000);

      } catch (err) {
        console.error(err);
        setSaveSuccess("Failed to remove");
      }
    };

  const handleBackgroundChange = (src) => {
      setSelectedBg(src);

      // stop old
      if (bgAudio) {
        bgAudio.pause();
        bgAudio.currentTime = 0;
      }

      if (src === "none") return;

      const audio = new Audio(src);
      audio.loop = true;
      audio.volume = 0.3; // soft ambient
      audio.play();

      setBgAudio(audio);
  };

  const handleTranslate = async (userNeed) => {
    // console.log("Translating with need:", userNeed);
    if (!userNeed.trim()) return;
    // console.log("Translating with need1:", userNeed);
    setStatus("Remixing to your need...");
    setTranslating(true);
      mixpanel.track("Remixing", {
        tag: userNeed
    });

    try {

      // ✅ SAVE TO FIRESTORE IF NEW
      if (!savedNeeds.includes(userNeed)) {
        const ref = collection(db, "subusers", user.uid, "needs");

        await addDoc(ref, {
          text: userNeed,
          createdAt: serverTimestamp()
        });

        // update UI instantly
        setSavedNeeds(prev => [userNeed, ...prev]);
      }

      const res = await fetch("/api/translate-sub", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          original: sub.content,
          need: userNeed,
        }),
      });

      const data = await res.json();
      setShowNeedModal(false);
      setDisplayedContent(data.text);
      setIsTranslated(true);

    } catch (err) {
      console.error(err);
      // console.log("Translation failed, showing original content", err);
    }

    setStatus("← Swipe →");
    setTranslating(false);
    setUserNeed("");
  };

  const fetchNeeds = async () => {
    if (!user) return;

    // get needs
    const ref = collection(db, "subusers", user.uid, "needs");
    const snapshot = await getDocs(ref);
    const data = snapshot.docs.map(doc => doc.data().text);
    // 🔥 merge defaults + user needs (no duplicates)
  const combined = [...new Set([...DEFAULT_NEEDS, ...data])];
    setSavedNeeds(combined);

    // ✅ get official need
    const userRef = doc(db, "subusers", user.uid);

    const userDoc = await getDoc(userRef); // ✅ correct
    if (userDoc.exists()) {
      setOfficialNeed(userDoc.data().officialNeed || "");
    }
  };


  const unlockAudio = async () => {
    if (audioUnlocked) return;
    try {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      await audioCtx.resume(); // 🔥 unlocks audio
      setAudioUnlocked(true);
      setShowPlayOverlay(false); // hide play overlay after first unlock
    } catch (e) {
      console.log("unlock failed");
    }
  };

  const clearOfficialNeed = async () => {
    try {
      const userRef = doc(db, "subusers", user.uid);

      // 🔥 Clear from Firestore
      await updateDoc(userRef, {
        officialNeed: ""
      });

      // 🔥 Clear locally
      setOfficialNeed("");

      // 🔥 Reset UI back to original sub
      setDisplayedContent(sub.content);
      setIsTranslated(false);

    } catch (err) {
      console.error(err);
    }
  };

  const pillBtn = {
    fontSize: "12px",
    color: "#6f6f6f",
    background: "#e0e2e4",
    padding: "4px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const glassModal = {
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    padding: "20px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.1)"
  };

  const headerStyle = {
    fontWeight: 600,
    fontSize: 18,
    textAlign: "center",
    marginBottom: 15,
    position: "relative"
  };

  const backBtn = {
    position: "absolute",
    left: 0,
    cursor: "pointer",
    fontSize: "18px",
  };

  const folderRow = {
    padding: "12px",
    borderRadius: "12px",
    background: "#f9fafb",
    marginBottom: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  };

  const playlistRow = {
    padding: "12px",
    borderRadius: "12px",
    background: "#f9fafb",
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
    gap: 10
  };

  const divider = {
    height: 1,
    background: "#eee",
    margin: "15px 0"
  };

  const inputStyle = {
    borderRadius: 12,
    marginBottom: 10
  };

  const primaryBtn = {
    width: "100%",
    background: "#111",
    color: "white",
    border: "none",
    borderRadius: "12px",
    padding: "10px"
  };

  const stopBackgroundAudio = () => {
  if (bgAudio) {
    bgAudio.pause();
    bgAudio.currentTime = 0;
    setBgAudio(null);
  }
};

  return (
    <div
      // {...handlers}
      style={{
        width: "100%",
        height: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "20px 16px",
        color: "white",
        background: "linear-gradient(to top, #000, #111)",
        position: "relative"
      }}
    >
    {/* SWIPEABLE AREA */}
<div {...handlers} style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>

      {/* TOP USER */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src={sub.userPhoto}
          style={{ width: 42, height: 42, borderRadius: "50%" }}
        />
        <span style={{ fontWeight: 600 }}>
          @{sub.username?.replace(/\s+/g, "")}
        </span>
      </div>

      {/* CENTER CONTENT */}
<div
  style={{
    position: "relative",
    height: "35vh", // ✅ fixed vertical space (adjust: 30–45vh feels best)
    maxHeight: "300px", // ✅ safety cap for large screens
    overflow: "hidden", // container stays fixed
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
    padding: "0 10px"
  }}
>
  {/* SCROLLABLE TEXT */}
  <div
    style={{
      width: "100%",
      height: "100%",
      overflowY: "auto", // ✅ enables vertical scroll
      padding: "10px",
      textAlign: "center",
      fontSize: "clamp(28px, 5vw, 28px)",
      fontWeight: 800,
      lineHeight: 1.4,

      // optional polish 👇
      scrollbarWidth: "none", // Firefox
      msOverflowStyle: "none" // IE
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100%" // keeps short text centered
      }}
    >
      {isEditing ? (
        <textarea
          value={editedContent}
          onChange={(e) => setEditedContent(e.target.value)}
          autoFocus
          style={{
            width: "100%",
            // height: "100%",
            background: "transparent",
            color: "white",
            border: "none",
            outline: "none",
            resize: "none",
            textAlign: "center",
            fontSize: "clamp(28px, 5vw, 28px)",
            fontWeight: 800,
            lineHeight: 1.4,
            caretColor: "white",
            height: "35vh", // ✅ fixed vertical space (adjust: 30–45vh feels best)
            maxHeight: "300px", // ✅ safety cap for large screens
          }}
        />
      ) : (
        displayedContent
      )}
    </div>
  </div>

  {/* 🎯 CENTER PLAY OVERLAY */}
  {showPlayOverlay && (
    <button
      onClick={async () => {
        await unlockAudio();
        handlePlay();
        setShowPlayOverlay(false);
      }}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 45,
        height: 45,
        borderRadius: "50%",
        background: "rgba(255, 255, 255, 0.97)",
        color: "red",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 26,
        boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
        zIndex: 10,
        backdropFilter: "blur(10px)",
        transition: "all 0.25s ease",
        animation: "pulse 2s infinite",
        border: "none",

      }}
    >
      <FaPlay style={{width: 20, height: 20, marginLeft: 4}}/>
    </button>
  )}
  
</div>


      {/* BOTTOM CONTROLS */}
      <div>
        {/* 🎚 Acceptance Meter */}
        {/* <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 4 }}>
            How effective is it ? 
            {resistance / 20}/5 
          </div>

          <div
            style={{
              height: 6,
              borderRadius: 10,
              background: `linear-gradient(to right, white ${resistance}%, rgba(255,255,255,0.2) ${resistance}%)`
            }}
          />

          <input
            type="range"
            min="0"
            max="100"
            value={resistance}
            onChange={(e) => setResistance(e.target.value)}
            style={{ width: "100%", opacity: 0, }}
          />
        </div> */}


         {/* Swipe hint */}
        {/* <div
          style={{
            position: "absolute",
            bottom: 180, // 👈 adjust this (key control)
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 12,
            opacity: 0.45,
            letterSpacing: "0.5px"
          }}
        >
          ← Swipe →
        </div> */}

        {/* 🎮 Controls */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10
          }}
        >
        
          {/* Subliminal toggle */}
          {/* <div
            onClick={() => setSubliminalOn(!subliminalOn)}
            style={{
              width: 44,
              height: 24,
              borderRadius: 20,
              background: subliminalOn ? "#61b402" : "#444",
              display: "flex",
              alignItems: "center",
              padding: 3
            }}
          >
          
              <div
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  background: subliminalOn ? "#fff" : "#fff",
                  transform: subliminalOn
                    ? "translateX(20px)"
                    : "translateX(0px)",
                  transition: "0.2s"
                }}
              />
            
          </div> */}

          <div
            
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              // cursor: "pointer"
            }}
          >
            {/* BUTTON */}
            <button
              onClick={handleFavorite}
              style={{
                width: 45,
                height: 45,
                borderRadius: "50%",
                background: favoriteOn
                  ? "linear-gradient(135deg, #ff3b3b, #b30000)"
                  : "rgba(255,255,255,0.12)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: favoriteOn
                  ? "0 6px 20px rgba(255, 0, 0, 0.35)"
                  : "0 4px 12px rgba(0,0,0,0.25)",
                transition: "all 0.25s ease",
              }}
            >
              <img
                src={favoriteOn ? "/lovew.png" : "/loveg.png"}
                alt="winner"
                style={{
                  width: 24,
                  height: 24,
                  transition: "transform 0.2s ease",
                  transform: favoriteOn ? "scale(1.1)" : "scale(1)"
                }}
              />

              {/* <FaPlus style={{ color: favoriteOn ? "white" : "grey"}}/> */}
            </button>

            {/* COUNT */}
            <div
              style={{
                fontSize: 13,
                fontWeight: 500,
                color: "rgba(255,255,255,0.85)",
                letterSpacing: "0.3px"
              }}
            >
              {/* {winnerCount} */}
              {playlistCount}
            </div>
          </div>

          {status && (
            <div
              style={{
                position: "absolute",
                // bottom: 10,
                left: "50%",
                transform: "translateX(-50%)",
                padding: "6px 14px",
                borderRadius: 20,
                background: "rgba(0,0,0,0.6)",
                backdropFilter: "blur(10px)",
                fontSize: 12,
                color: "white",
                letterSpacing: "0.3px",
                animation: "fadePulse 1.5s infinite",
                zIndex: 9,
              }}
            >
              {status}
            </div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6
            }}
          >
            {/* BUTTON */}
            <button
              onClick={async () => {
                if (!isEditing) {
                  setIsEditing(true);
                  setStatus("Editing...");
                  return;
                }

                // 💾 SAVE MODE
           
                const trimmed = editedContent.trim();

                // ❌ 1. STOP if nothing changed
                if (!trimmed || trimmed === displayedContent.trim()) {
                  setIsEditing(false);
                  setEditedContent(displayedContent); // 🔥 reset back
                  setStatus("← Swipe →");
                  return;
                }

                try {
                  setSavingEdit(true);

                  const subRef = doc(db, "subs", sub.id);

                  // ✅ 2. ALWAYS get username from subusers
                  let username = "Anonymous";
                  const userRef = doc(db, "subusers", user.uid);
                  const userSnap = await getDoc(userRef);

                  if (userSnap.exists()) {
                    username = userSnap.data().username;
                  }


                  // ✅ CASE 1: editing your own sub → UPDATE
                  if (sub.userId === user.uid && !isTranslated) {
                    await updateDoc(subRef, {
                      content: editedContent,
                      username: username, 
                      updatedAt: serverTimestamp()
                    });

                    // instant UI update
                    setDisplayedContent(editedContent);
                  }

                  // ✅ CASE 2: editing someone else's → FORK
                  else {
                    // ✅ sanitize lineage safely
                    const safeLineage = Array.isArray(sub.lineage)
                      ? sub.lineage.filter(
                          (l) => l && l.userId && l.subId
                        )
                      : [];

                    const newLineageItem =
                      sub.userId && sub.id
                        ? {
                            userId: sub.userId,
                            subId: sub.id,
                            timestamp: new Date()
                          }
                        : null;

                    await addDoc(collection(db, "subs"), {
                      content: editedContent,
                      userId: user.uid, // new owner
                      userPhoto: user.photoURL || "",
                      username: username || user.displayName,

                      // 🔥 lineage tracking
                      parentSubId: sub.id,
                      rootSubId: sub.rootSubId || sub.id,
                      // lineage: [
                      //   ...(sub.lineage || []),
                      //   {
                      //     userId: sub.userId,
                      //     subId: sub.id,
                      //     timestamp: new Date(),
                      //   }
                      // ],
                      lineage: newLineageItem
                      ? [...safeLineage, newLineageItem]
                      : safeLineage,

                      createdAt: serverTimestamp(),
                      winners: [],
                      playlistUsers: [],
                      playCount: 0
                    });

                    setDisplayedContent(editedContent);
                  }

                  // update UI immediately
                  // setDisplayedContent(editedContent);

                  setIsEditing(false);
                  setStatus("← Swipe →");
                  // await onEditSuccess?.(sub.id);
                  // onSwipe?.("right"); // optional: swipe to next after edit
                  window.location.reload();
                } catch (err) {
                  console.error(err);
                  alert("Failed to save edit");
                } finally {
                  setSavingEdit(false);
                }
              }}
              style={{
                width: 45,
                height: 45,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #ff3b3b, #b30000)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 6px 20px rgba(255, 0, 0, 0.35)",
                transition: "all 0.25s ease",
                // border: "none",
              }}
            >
             
               {isEditing ? (
                  <FaCheck style={{ width: 20, height: 20, color: "white" }} />
                ) : (
                  <FaPen style={{ width: 20, height: 20, color: "white" }} />
                )}
            </button>

            {/* INVISIBLE PLACEHOLDER (balances height) */}
            <div
              style={{
                fontSize: 13,
                fontWeight: 500,
                visibility: "hidden", // hides text but keeps space
                color: "rgba(255,255,255,0.85)",
                letterSpacing: "0.3px"
              }}
            >
              {playlistCount}
            </div>
          </div>
          
        </div>

        </div>


 
       
      </div>

      {/* <div style={{ height: 0.1, background: "#444444", marginTop: "15px"}} /> */}

   
{/* 🎛 MAIN AUDIO CONTROLS (AMBIENT) */}
<div
  style={{
    marginTop: 14,
    padding: "14px",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.06)",
    display: "flex",
    flexDirection: "column",
    gap: 12
  }}
>

 {/* 🧠 Subliminal toggle */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span style={{ fontSize: 11 }}>Subliminal Mode ?</span>
      {/* <span style={{ fontSize: 10, opacity: 0.5 }}>
        Low frequency playback
      </span> */}
    </div>

    <div
      onClick={() => setSubliminalOn(!subliminalOn)}
      style={{
        width: 40,
        height: 22,
        borderRadius: 20,
        background: subliminalOn ? "#61b402" : "rgba(255,255,255,0.2)",
        display: "flex",
        alignItems: "center",
        padding: "3px",
        cursor: "pointer",
        transition: "0.2s"
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          background: "white",
          transform: subliminalOn
            ? "translateX(18px)"
            : "translateX(0px)",
          transition: "0.2s"
        }}
      />
    </div>
  </div>

   {/* 🌍 TRANSLATION SECTION */}

<div style={{ fontSize: 11, opacity: 0.5, marginBottom: 0, marginTop: 0}}>
  Remix Tags
</div>
<div
  style={{
    marginTop: 0,
    marginBottom: 0,
    padding: "0px",
    borderRadius: "18px",
    background: "rgba(0, 0, 0, 0.06)",
    backdropFilter: "blur(20px)",
    // border: "1px solid rgba(255,255,255,0.08)",
  }}
>


<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8
  }}
>

  {/* SCROLLABLE CHIPS */}
  <div
    style={{
      display: "flex",
      gap: 8,
      overflowX: "auto",
      flex: 1,
      paddingBottom: 4
    }}
  >
    {savedNeeds.length === 0 ? (
      <div
        style={{
          fontSize: 12,
          opacity: 0.5,
          whiteSpace: "nowrap",
          padding: "6px 4px"
        }}
      >
        Add tags to remix any sub into your needs e.g "lose weight" etc
      </div>
    ) : (
      savedNeeds.map((need, i) => (
        <button
          key={i}
           onClick={async () => {
               // 🔥 If already selected → UNSELECT
              if (officialNeed === need) {
                await clearOfficialNeed();
                return;
              }

               setUserNeed(need);
               setOfficialNeed(need); // instant UI update

                // ✅ save to Firestore
                const userRef = doc(db, "subusers", user.uid);
                await updateDoc(userRef, {
                  officialNeed: need
                });
              // await handleTranslate(need);
              // setShowNeedModal(false);
            }}
          style={{
            padding: "6px 12px",
            borderRadius: "999px",
            background:
              officialNeed === need
                ? "white"
                : "rgba(255,255,255,0.1)",
            color: officialNeed === need ? "#023304" : "#fff",
            fontSize: 12,
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "0.2s",
            border: "none",
            height: 35,
          }}
        >
          {need}
        </button>
      ))
    )}
  </div>

  {/* ➕ FIXED ADD BUTTON (ALWAYS VISIBLE) */}
  <div
    onClick={() => setShowNeedModal(true)}
    style={{
      minWidth: 34,
      height: 34,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.18)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      backdropFilter: "blur(12px)",
      // border: "1px solid rgba(255,255,255,0.25)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      transition: "all 0.2s ease"
    }}
    onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.92)")}
    onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <FaPlus size={12} />
  </div>
</div>
</div>


  {/* 🎧 Background selector */}
  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
    
    <div style={{ fontSize: 11, opacity: 0.5, marginBottom: 4, marginTop: 4 }}>
      Background Sound
    </div>

    <select
      value={selectedBg}
      onChange={(e) => handleBackgroundChange(e.target.value)}
      style={{
        width: "100%",
        border: "1px solid black",
        outline: "none",
        background: "rgba(243, 213, 213, 0.08)",
        color: "white",
        padding: "10px",
        borderRadius: "10px",
        fontSize: 13
      }}
    >
      {backgroundSounds.map(s => (
        <option
          key={s.value}
          value={s.value}
          style={{ color: "black" }} // ✅ FIX
        >
          {s.name}
        </option>
      ))}
    </select>
  </div>


 
</div>

        {/* 💾 MODAL */}
    <Modal show={showModal} 
      onHide={() => {
        stopPlayAll(); // stop playlist if open
        stopBackgroundAudio(); // ✅ stop bg sound
        // setCurrentAudio(null);    // ✅ stop voice too
        setShowModal(false);
        // setBgAudio(null);
        setView("folders");
        // setWeOut(true);
        // currentAudio?.stop?.();

        // now go to next card
        // onSwipe?.("right");
      }} 
      centered>

      <div style={glassModal}>

        {/* HEADER */}
        <div style={headerStyle}>
          {view === "playlist" && (
            <span
              onClick={() => 
              {
                stopPlayAll(); 
                // setCurrentAudio(null);
                stopBackgroundAudio();
                // setBgAudio(null);
              setView("folders");
              // setWeOut(true);
              // currentAudio?.stop?.();
              }}
              style={backBtn}
            >
              <img
                src="/arrow2.png"
                alt="delete"
                style={{ width: 14, filter: "invert(0)" }}
              />
            </span>
          )}

          <div>
            {view === "folders"
              ? "Add to Playlist"
              : selectedFolder?.name}
          </div>
        </div>

        {/* ✅ SUCCESS MESSAGE */}
        {saveSuccess && (
          <div
            style={{
              background: "#e6f9f0",
              color: "#0f5132",
              padding: "10px",
              borderRadius: "10px",
              fontSize: "13px",
              textAlign: "center",
              marginBottom: "12px"
            }}
          >
            {saveSuccess}
          </div>
        )}

        {/* ========================= */}
        {/* 📁 FOLDER VIEW */}
        {/* ========================= */}
        {view === "folders" && (
          <>
            <div>
              {folders.map(folder => (
                <div key={folder.id} style={folderRow}>
                  
                  <span>{folder.name}</span>

                  <div style={{ display: "flex", gap: 8 }}>
                    

                    {/* PLAY → OPEN PLAYLIST */}
                    <span
                      style={pillBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        openPlaylist(folder);
                      }}
                    >
                      <FaPlay />
                    </span>

                    {/* ADD */}
                    <span
                      style={pillBtn}
                      onClick={() => saveToFolder(folder.id)}
                    >
                      <FaPlus />
                    </span>
                  </div>

                </div>
              ))}
            </div>

            {/* CREATE */}
            <div style={divider} />

            <div style={{ position: "relative" }}>
  <Form.Control
    placeholder="New Playlist"
    value={newFolderName}
    onChange={(e) => setNewFolderName(e.target.value)}
    style={{
      ...inputStyle,
      paddingRight: "40px" // space for icon
    }}
  />

  {/* ➕ CREATE BUTTON (RIGHT SIDE INSIDE INPUT) */}
  <button
    onClick={createFolder}
    disabled={!newFolderName.trim()}
    style={{
      position: "absolute",
      right: 8,
      top: "50%",
      transform: "translateY(-50%)",
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: "none",
      background: "#111",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 12,
      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      opacity: newFolderName.trim() ? 1 : 0.4,
      cursor: newFolderName.trim() ? "pointer" : "default"
    }}
  >
    <FaPlus />
  </button>
</div>
          </>
        )}

        {/* ========================= */}
        {/* 🎧 PLAYLIST VIEW */}
        {/* ========================= */}
        {view === "playlist" && (
  <>
    {/* ✅ SCROLLABLE SUB LIST */}
    <div
      style={{
        marginTop: 15,
        maxHeight: "250px", // 👈 controls height
        overflowY: "auto",
        paddingRight: "4px"
      }}
    >
      {playlistSubs.map(item => (
        <div key={item.id} style={playlistRow}>
          
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14 }}>
              {item.content.substring(0, 30)}...
            </div>
          </div>

          {/* ▶️ PLAY */}
          <span
            style={{...pillBtn,
            // background: "#eaffe5",
              }}
            onClick={() => {handlePlayText(item.content)
                                mixpanel.track("PlayText", {
                                  sub: item.content
                                });
                              
                            }}
          >
            <FaPlay />
          </span>

          {/* 🗑 DELETE */}
          <span
            style={{
              ...pillBtn,
              background: "#ffe5e5",
              // color: "#b00020"
            }}
            onClick={() => removeFromFolder(item.id)}
          >
            <img
              src="/remove.png"
              alt="delete"
              style={{ width: 14, filter: "invert(1)" }}
             />
          </span>

        </div>
      ))}
    </div>

    {/* ✅ DIVIDER */}
    <div style={{ height: 1, background: "#eee", margin: "15px 0" }} />

    {/* ================= CONTROLS ================= */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        marginBottom: 20
      }}
    >

      {/* 🎧 Background selector */}
      <div
        style={{
          background: "#f9fafb",
          padding: "12px",
          borderRadius: "14px"
        }}
      >
        <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>
          Background Sound
        </div>

        <select
          value={selectedBg}
          onChange={(e) => handleBackgroundChange(e.target.value)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: 14
          }}
        >
          {backgroundSounds.map(s => (
            <option key={s.value} value={s.value}>
              {s.name}
            </option>
          ))}
        </select>
      </div>

      {/* 🧠 Subliminal toggle */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#f9fafb",
          padding: "12px",
          borderRadius: "14px"
        }}
      >
        <div>
          <div style={{ fontSize: 14, fontWeight: 500 }}>
            Subliminal Mode
          </div>
          <div style={{ fontSize: 11, color: "#888" }}>
            Use subliminal frequency
          </div>
        </div>

        <div
          onClick={() => {setSubliminalOn(!subliminalOn);
            mixpanel.track("subliminal ON ?", {
                subliminal: subliminalOn
            });
          }}
          style={{
            width: 42,
            height: 24,
            borderRadius: 20,
            background: subliminalOn ? "#61b402" : "#ddd",
            display: "flex",
            alignItems: "center",
            padding: "3px",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              background: "white",
              transform: subliminalOn
                ? "translateX(18px)"
                : "translateX(0px)",
              transition: "0.2s"
            }}
          />
        </div>
      </div>
    </div>

    {/* ▶️ PLAY ALL */}
    <button onClick={{playAll}} 
      style={{ ...primaryBtn }}>
      <img
              src="/autoplay.png"
              alt="delete"
              style={{ width: 22, filter: "invert(0)" }}
             />
              {/* Play All */}
    </button>
  </>
)}

      </div>
    </Modal>


    <Modal
      show={showNeedModal}
      onHide={() => setShowNeedModal(false)}
      centered
    >
      <div
        style={{
          // background: "rgba(20,20,20,0.85)",
          backdropFilter: "blur(25px)",
          borderRadius: "24px",
          padding: "24px",
          boxShadow: "0 30px 80px rgba(213, 210, 210, 0.4)",
          border: "1px solid rgba(252, 251, 251, 0.08)",
          color: "white"
        }}
      >
        {/* HEADER */}
        <div
          style={{
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 16,
            textAlign: "center",
            letterSpacing: "0.3px",
            color: "rgba(82, 82, 82, 0.9)"
          }}
        >
          Add Remix Tags
        </div>

        {/* INPUT */}
        <div style={{ position: "relative" }}>
          <input
            autoFocus
            placeholder="What do you want instead?"
            value={userNeed}
            onChange={(e) => setUserNeed(e.target.value)}
            style={{
              width: "100%",
              padding: "14px 44px 14px 14px",
              borderRadius: "14px",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              outline: "none",
              fontSize: 14,
              background: "rgba(255,255,255,0.05)",
              // color: "white",
              backdropFilter: "blur(10px)"
            }}
          />

          {/* TRANSLATE BUTTON */}
          <button
            onClick={async () => {
              await handleTranslate(userNeed);
              setShowNeedModal(false);
            }}
            disabled={translating}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              border: "none",
              background: "transparent",
              cursor: "pointer",
              opacity: translating ? 0.5 : 1
            }}
          >
            {/* <img
              src={translating ? "/translatered.png" : "/translateb.png"}
              alt="translate"
              style={{ width: 18 }}
            /> */}
            <FaPlus color={translating ? "#ff4d4d" : "#383838"} />
          </button>
        </div>

        {/* ACTION ROW */}
        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 18
          }}
        >
         
        </div>
      </div>
    </Modal>
    </div>
  );
}

const iconBtn = {
  border: "none",
  background: "#f3f4f6",
  padding: "8px 10px",
  borderRadius: "10px",
  cursor: "pointer"
};



    
